import { useEffect, useState } from 'react'
import { Input, Divider } from 'antd'
import { useCreateMacroData } from '../CreateMacroDataProvider'
import { setFieldData } from '../CreateMacroDataProvider/actions'
import FormLikeField from './FormLikeField'

DateTimeConfig = ({ fieldKey }) ->

  [{ fieldData }, dispatch] = useCreateMacroData()

  setConfig = (key) -> ({ target: { value }}) ->
    dispatch(
      setFieldData(
        _.set(fieldData, [fieldKey, 'save', 'attributes', key], value)
      )
    )

  <>
    <FormLikeField label="Datetime attribute">
      <Input
        value={fieldData[fieldKey]?.save?.attributes?[0]}
        placeholder={fieldData[fieldKey]?.save?.attributes?[0]}
        onChange={setConfig('0')}
      />
    </FormLikeField>
    <Divider />
  </>

export default DateTimeConfig